module.exports = __webpack_public_path__ + "static/media/promo-v2-4.18d72f00.jpeg";